export const SET_BUSINESS_DAY_SETTINGS_DATA_LOADING =
  'SET_BUSINESS_DAY_SETTINGS_DATA_LOADING';
export const SET_BUSINESS_DAY_SETTINGS_DATA = 'SET_BUSINESS_DAY_SETTINGS_DATA';
export const CLEAR_BUSINESS_DAY_SETTINGS_DATA = 'CLEAR_BUSINESS_DAY_SETTINGS_DATA';
